import {
  Swiper,
  Autoplay,
} from 'swiper';
import type { SwiperOptions } from 'swiper';

Swiper.use([
  Autoplay,
]);

const uspsInit = (slider: HTMLElement) => {
  // Default options for each swiper instance
  const defaultOptions: SwiperOptions = {
    loop: true,
    speed: 500,
    keyboard: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    slideActiveClass: 'slider__slide--active',
  };

  return new Swiper(slider, { ...defaultOptions });
};

export default uspsInit;
